import axios from '@/utils/request';

// 获取学习地图列表
export const getLearningMaps = (data: any) => {
  return axios.request({
    url: 'LearningMap/GetLearningMaps',
    method: 'GET',
    params: data,
  });
};

// 获取学习地图路径
export const getLearningMapPath = (data: any) => {
  return axios.request({
    url: 'LearningMap/GetLearningMapPath',
    method: 'GET',
    params: data,
  });
};

// 获取地图岗位详情
export const getMapPathDetails = (data: any) => {
  return axios.request({
    url: 'LearningMap/GetLearningMapPathDetails',
    method: 'GET',
    params: data,
  });
};

// 获取地图岗位课程
export const getMapPostCourses = (data: any) => {
  return axios.request({
    url: 'LearningMap/GetLearningMapPostCourses',
    method: 'GET',
    params: data,
  });
};
